// extracted by mini-css-extract-plugin
export var casesCard = "cases-card-module--cases-card--Plif8";
export var casesCard__image = "cases-card-module--cases-card__image--8u1CL";
export var casesCard__content = "cases-card-module--cases-card__content--s310s";
export var casesCard__metric = "cases-card-module--cases-card__metric--ijn5J";
export var casesCard__desc = "cases-card-module--cases-card__desc--zeggf";